let container;
export function getContainer() {
    findOrCreateContainer();
    return container;
}
function findOrCreateContainer() {
    if (container)
        return;
    const overlayContainer = document.querySelector('#overlay-container');
    if (!overlayContainer) {
        throw new Error(`Overlay container not init`);
    }
    container = overlayContainer;
}
//# sourceMappingURL=overlay-container.js.map